// Export the Component Definition for use in Contentful Studio
export {CardCollectionContentfulComponentDefinition} from './CardCollectionContentfulDefinition';
export {default} from './CardCollection';
